export default __webpack_public_path__ + "static/platform4-0a0f3b68cde6cfaf56bf3b9e24611244.svg";